export default {
    menus() {
        return [{
                "id": 1,
                "caption": "Sospechosos",
                "name": null,
                "fecha_creacion": "2018-10-23T17:34:18.047",
                "usuario_creacion": "adm",
                "fecha_actualizacion": "2018-10-23T17:34:18.047",
                "usuario_actualizacion": "adm",
                "activo": true,
                "submenus": [{
                        "id_submenu": 1,
                        "caption_submenu": "Baneados",
                        "activo": true
                    },
                    {
                        "id_submenu": 7,
                        "caption_submenu": "Eliminar Test",
                        "activo": true
                    }
                ]
            },
            {
                "id": 2,
                "caption": "Opciones",
                "name": "options",
                "fecha_creacion": "2018-10-23T17:34:18.047",
                "usuario_creacion": "adm",
                "fecha_actualizacion": "2018-10-23T17:34:18.047",
                "usuario_actualizacion": "adm",
                "activo": true,
                "submenus": null
            },
            {
                "id": 3,
                "caption": "Clientes",
                "name": "clients",
                "fecha_creacion": "2018-10-23T17:34:18.047",
                "usuario_creacion": "adm",
                "fecha_actualizacion": "2018-10-23T17:34:18.047",
                "usuario_actualizacion": "adm",
                "activo": true,
                "submenus": null
            },
            {
                "id": 4,
                "caption": "Usuarios",
                "name": "users",
                "fecha_creacion": "2018-10-31T00:00:00",
                "usuario_creacion": "adm",
                "fecha_actualizacion": "2018-10-31T00:00:00",
                "usuario_actualizacion": "adm",
                "activo": true,
                "submenus": null
            },
            {
                "id": 5,
                "caption": "DFP",
                "name": null,
                "fecha_creacion": "2018-12-06T00:00:00",
                "usuario_creacion": "adm",
                "fecha_actualizacion": "2018-12-06T00:00:00",
                "usuario_actualizacion": "adm",
                "activo": true,
                "submenus": [{
                        "id_submenu": 2,
                        "caption_submenu": "Leads",
                        "activo": true
                    },
                    {
                        "id_submenu": 5,
                        "caption_submenu": "Crear campaña",
                        "activo": true
                    },
                    {
                        "id_submenu": 6,
                        "caption_submenu": "Formularios",
                        "activo": true
                    }
                ]
            },
            {
                "id": 6,
                "caption": "Usuarios LiveMarket",
                "name": "usersA",
                "fecha_creacion": "2019-01-07T00:00:00",
                "usuario_creacion": "adm",
                "fecha_actualizacion": "2019-01-07T00:00:00",
                "usuario_actualizacion": "adm",
                "activo": true,
                "submenus": null
            },
            {
                "id": 11,
                "caption": "Pagos",
                "name": "payments",
                "fecha_creacion": "2019-02-01T10:56:19.697",
                "usuario_creacion": "mvalladares",
                "fecha_actualizacion": "2019-02-01T11:00:40.417",
                "usuario_actualizacion": "mvalladares",
                "activo": true,
                "submenus": null
            },
            {
                "id": 12,
                "caption": "Callconnect",
                "name": "callconnect",
                "fecha_creacion": "2019-02-07T10:40:19.623",
                "usuario_creacion": "avivas@chileautos.cl",
                "fecha_actualizacion": "2019-02-07T10:40:19.623",
                "usuario_actualizacion": "avivas@chileautos.cl",
                "activo": true,
                "submenus": null
            },
            {
                "id": 13,
                "caption": "Sistemas",
                "name": "systems",
                "fecha_creacion": "2019-02-14T11:31:49.49",
                "usuario_creacion": "avivas@chileautos.cl",
                "fecha_actualizacion": "2019-02-14T11:31:49.49",
                "usuario_actualizacion": "avivas@chileautos.cl",
                "activo": true,
                "submenus": null
            },
            {
                "id": 14,
                "caption": "Clasificacion",
                "name": null,
                "fecha_creacion": "2019-03-07T13:09:02.8",
                "usuario_creacion": "avivas",
                "fecha_actualizacion": "2019-03-15T10:24:06.35",
                "usuario_actualizacion": "mvalladares",
                "activo": false,
                "submenus": null
            },
            {
                "id": 15,
                "caption": "Registro Civil",
                "name": null,
                "fecha_creacion": "2019-03-15T10:14:55.85",
                "usuario_creacion": "mvalladares",
                "fecha_actualizacion": "2019-03-15T10:14:55.85",
                "usuario_actualizacion": "mvalladares",
                "activo": true,
                "submenus": [{
                    "id_submenu": 8,
                    "caption_submenu": "Asociación",
                    "activo": true
                }]
            },
            {
                "id": 16,
                "caption": "Pagos Destacados",
                "name": "destacadosPayments",
                "fecha_creacion": "2019-05-16T07:47:18.437",
                "usuario_creacion": "avivas",
                "fecha_actualizacion": "2019-05-16T07:47:18.437",
                "usuario_actualizacion": "avivas",
                "activo": true,
                "submenus": null
            },
            {
                "id": 17,
                "caption": "Leads",
                "name": null,
                "fecha_creacion": "2019-07-10T12:09:20.66",
                "usuario_creacion": "csanhueza",
                "fecha_actualizacion": "2019-07-10T12:09:20.66",
                "usuario_actualizacion": "csanhueza",
                "activo": true,
                "submenus": [{
                    "id_submenu": 9,
                    "caption_submenu": "Cargar Archivo",
                    "activo": true
                }]
            },
            {
                "id": 18,
                "caption": "Avisos",
                "name": null,
                "fecha_creacion": "2019-07-11T10:50:32.41",
                "usuario_creacion": "mvalladares",
                "fecha_actualizacion": "2019-07-11T10:50:32.41",
                "usuario_actualizacion": "mvalladares",
                "activo": true,
                "submenus": null
            },
            {
                "id": 19,
                "caption": "Lista Blanca",
                "name": null,
                "fecha_creacion": "2019-07-11T10:51:25.103",
                "usuario_creacion": "mvalladares",
                "fecha_actualizacion": "2019-07-11T10:51:25.103",
                "usuario_actualizacion": "mvalladares",
                "activo": true,
                "submenus": [{
                    "id_submenu": 10,
                    "caption_submenu": "Crear Modelo",
                    "activo": true
                }]
            },
            {
                "id": 20,
                "caption": "Avisos",
                "name": null,
                "fecha_creacion": "2019-07-18T16:20:48.91",
                "usuario_creacion": "mvalladares",
                "fecha_actualizacion": "2019-07-18T16:20:48.91",
                "usuario_actualizacion": "mvalladares",
                "activo": true,
                "submenus": [{
                    "id_submenu": 11,
                    "caption_submenu": "Eliminar Fantasmas",
                    "activo": true
                }]
            },
            {
                "id": 21,
                "caption": "Departamentos",
                "name": null,
                "fecha_creacion": "2019-07-30T09:14:12.507",
                "usuario_creacion": "avivas@chileautos.cl",
                "fecha_actualizacion": "2019-07-30T09:58:54.387",
                "usuario_actualizacion": "avivas@chileautos.cl",
                "activo": true,
                "submenus": [{
                        "id_submenu": 12,
                        "caption_submenu": "Menus",
                        "activo": true
                    },
                    {
                        "id_submenu": 13,
                        "caption_submenu": "Listar Deptos",
                        "activo": true
                    }
                ]
            }
        ]
    }
}